<template>
  <div>
    <button
     v-if="isCliped"
     class="button pa-additional-button pa-park-unclip-button"
     @click.prevent="handleClickButton"
    >クリップを解除する</button>

    <PAParkUnClipConfirmModal
     :parkId="parkId"
     :isOpenModal="isOpenModal"
     :isSubmitLoading="isSubmitLoading"
     @onClickSubmit="handleClickSubmit"
     @onClickCancel="handleClickCancel"
     @onCloseOverlay="handleCloseOverlay"
    />
  </div>
</template>

<script>
import PAParkUnClipConfirmModal from '@/components/Pages/Parks/Detail/PAParkUnClipConfirmModal.vue'

import {UnClipPark} from '@/graphql/mutations/Park.graphql'

import {GetParkData} from '@/graphql/queries/Park.graphql'

export default {
  props : {
    parkId : {
      default: null
    }
  },

  components : {
    PAParkUnClipConfirmModal
  },

  data(){
    return {
      isOpenModal     : false,
      isSubmitLoading : false,
      isCliped        : false,
    };
  },

  apollo : {
    park : {
      query : GetParkData,

      variables(){
        return {
          id : this.parkId
        };
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },
  },

  watch : {
    park : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(data !== null){
          this.isCliped = data.is_clipped;
        }
      },
      immediate: true,
      deep:true
    }
  },

  methods : {
    handleClickButton(){
      this.isOpenModal = true;
    },

    async handleClickSubmit(){
      this.isSubmitLoading = true;
      
      await this.UXWaiting(1000);

      const result = await this.executeUnClipPark();

      if(result === true){
        this.$store.dispatch({
          type        : 'parkList/updateRemoveParkInList',
          listType    : 'related',
          parkId      : this.parkId
        });

        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;クリップを解除しました。',
          status      : 'primary',
          hasControl  : true,
          autoClose   : 3000
        }, {root:true});
      }
      
      this.isSubmitLoading = false;
      
      this.isOpenModal = false;

      // ひろばトップに飛ばします。
      this.$router.push({ name: 'parks.view' });
    },

    executeUnClipPark(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UnClipPark,
          variables : {
            parkId      : this.parkId
          }
          //, update    : (store, {data:{UnClipPark:{park}}}) => {
          //   store.writeQuery({
          //     query     : GetParkData,
          //     variables : {
          //       id  : this.parkId
          //     },
          //     data      : {
          //       park : park
          //     }
          //   });
          // }
        }).then(async ({data: {UnClipPark:{result}}}) => {
          
          resolve(result);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    },

    handleClickCancel(){
      this.isOpenModal = false;
    },

    handleCloseOverlay(){
      this.isOpenModal = false;
    }
  }
}
</script>

<style lang="scss">
button.pa-park-unclip-button{
  background-color:#C8AD8D;
  color:#867057;
  border:0;
  padding:.6rem .4rem;
  margin:0 .5rem 0 0;
  line-height:1;
  font-size:.7rem;
  height:auto;

  &:hover, &:active, &:focus{
    color: #867057;
    background-color: #C8AD8D;
    border:0;
  }

  &:focus{
    box-shadow:none;
  }
}
</style>